import * as stylex from "@stylexjs/stylex";

export default function TechBadge({ children }) {
  return <span {...stylex.props(styles.badge)}>{children}</span>;
}

const styles = stylex.create({
  badge: {
    borderColor: {
      default: "var(--media-inner-border)",
      ":hover": "var(--primary-accent)",
    },
    borderRadius: "50px",
    borderStyle: "solid",
    borderWidth: "1px",
    transition: "all 0.2s ease",
    backgroundColor: {
      default: "var(--media-inner-border)",
      ":hover": "var(--primary-accent)",
    },
    boxShadow: {
      default: null,
      ":hover": "0 4px 12px rgba(0,0,0,0.1)",
    },
    color: {
      default: "var(--primary-text)",
      ":hover": "#FFFFFF",
    },
    cursor: "default",
    display: "inline-block",
    fontSize: "0.85rem",
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: "nowrap",
    paddingBottom: "0.5rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: "0.5rem",
  },
});
